export const detailsContainer = {
  width: '100%',
  padding: '10px 16px 20px 0',

  '@media (max-width: 1024px)': {
    padding: '16px',
  },
};

export const buttonsGroup = {
  display: 'flex',
  gap: '12px',
  marginTop: '10px',

  '.back-btn': {
    marginRight: 'auto',
  },
};

export const actionBtn = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  fontWeight: 500,
  fontSize: '15px',
  padding: '4px 16px',
  borderRadius: '20px',
  textTransform: 'capitalize',
  border: '1px solid var(--textMain)',

  '&.delete-btn': {
    color: 'var(--darkRed)',
    border: '1px solid var(--darkRed)',
  },

  '&.loading': {
    pointerEvents: 'none',
    opacity: 0.5,
  },

  '@media (max-width: 768px)': {
    padding: '4px',
    height: '32px',
    width: '32px',
  },
};

export const subLabelsContainer = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginTop: '12px',
  marginBottom: '8px',
};

export const subLabelsDate = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  marginLeft: 'auto',
};

export const mainContainer = {
  background: 'var(--white)',
  boxShadow: '0px 0px 20px 0px #0000000d',
  padding: '16px',
  marginBottom: '16px',
  borderRadius: '16px',
};

export const qrContainer = {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',

  '@media (max-width: 768px)': {
    flexWrap: 'wrap',
  },
};

export const scansCount = {
  width: '33%',
  borderRight: '1px solid var(--grey200)',

  '@media (max-width: 768px)': {
    width: '100%',
    borderRight: '0',
    borderBottom: '1px solid var(--grey200)',
  },
};

export const qrImage = {
  overflow: 'hidden',
  padding: '5px',
  width: '100px',
  height: '100px',
  border: '1px solid var(--grey200)',
  borderRadius: '12px',
  flexShrink: '0',
  marginLeft: 'auto',

  img: {
    display: 'block',
    maxWidth: '100%',
  },
};

export const qrDevice = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const accordion = {
  padding: '10px 0px',
  margin: '0 0 16px',
  
  '&.Mui-expanded': {
    margin: '0 0 16px',
  },
  '.basic-table': {
    boxShadow: 'none',
  },
};
